import React, { useEffect } from 'react';
import { useDocumensoRedirect } from '../../common/hooks/useDocumensoRedirect';
import { Box, Typography, Button } from '@mui/material';

const DocumentsPage = () => {
  const { redirectToDocumenso, isLoading, error } = useDocumensoRedirect();

  useEffect(() => {
    if (!isLoading && !error) {
      redirectToDocumenso('/documents');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
        <Typography>Redirecting to Documenso...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box display='flex' flexDirection='column' alignItems='center' gap={2} minHeight='200px'>
        <Typography color='error'>Error: {error}</Typography>
        <Button variant='contained' onClick={() => redirectToDocumenso('/documents')}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
      <Typography>Redirecting to Documenso...</Typography>
    </Box>
  );
};

export default DocumentsPage;
